module.exports = __webpack_public_path__ + "img/tlf_acum.afdd3c41.png";